import styled from "styled-components";
import breakpoints from "../../assets/styles/breakpoint";
import { COLORS } from "../../assets/utils/enums/colors";
import { useState } from "react";
import copyIcon from "../../assets/images/icons/copy-icon.svg";
import doneIcon from "../../assets/images/icons/done-icon-dark.svg";

interface ButtonProps {
  bgcolor: string;
  txtcolor: string;
  width: string;
  brcolor: string;
  brradius?: string;
  type: "small" | "large";
  noactive?: boolean;
}

export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.noactive ? COLORS["bg-text-color"] : props.bgcolor};
  color: ${(props) => (props.noactive ? COLORS.gray : props.txtcolor)};
  width: ${(props) => props.width};
  border-radius: ${(props) => props.brradius || "24px"};
  padding: ${(props) => (props.type === "large" ? "10px" : "8px 20px")};
  margin: 5px 0;
  border: 1px solid ${(props) => props.brcolor};
  outline: none;
  transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1);

  p {
    color: ${(props) => props.txtcolor};
    white-space: nowrap;
  }

  img {
    ${breakpoints.md} {
      width: 20px;
      height: 20px;
    }

    ${breakpoints.sm} {
      width: 16px;
      height: 16px;
    }
  }

  ${breakpoints.sm} {
    padding: 8px;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export function CopyButton({ text }: { text: string }) {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <CopyImage
      src={isCopied ? doneIcon : copyIcon}
      alt="copy-icon"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 1500);
        } catch (err) {
          console.error("Failed to copy text: ", err);
        }
      }}
    />
  );
}

const CopyImage = styled.img`
  width: 20px !important;
  height: 20px !important;
  margin: 0 4px;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:active {
    transform: scale(1.2);
  }
`;
